import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxTextComponent } from './phx-text.component';

@NgModule({
  declarations: [PhxTextComponent],
  imports: [CommonModule],
  exports: [PhxTextComponent],
})
export class PhxTextModule {}
